var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('FormulateInput',{attrs:{"name":"gender","options":_vm.inputOptions,"type":"radio","label":_vm.i18n.form.labels.gender,"validation":"required","validation-messages":_vm.i18n.form.validations.gender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }